import { LoggingService } from './logging.service';

export abstract class BaseService {
  constructor(protected loggingService: LoggingService) {}
}
